import { render, staticRenderFns } from "./pattern.vue?vue&type=template&id=156bf750&scoped=true&lang=pug&"
import script from "./pattern.vue?vue&type=script&lang=ts&"
export * from "./pattern.vue?vue&type=script&lang=ts&"
import style0 from "./pattern.vue?vue&type=style&index=0&id=156bf750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156bf750",
  null
  
)

export default component.exports